import {
  labelMappingDefinition,
  hwVerDefinition
} from "../const";

export const getMainSendRequestParams = ({ auth, method = "read" }) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiUrl = `${apiBaseUrl}/sites/:siteId/settings/wiredConfigProvisioning.${method}`;

  const requestParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.orgs?.id,
      siteId: auth.sites?.id,
    },
  };

  const requestParams = isStandaloneMode ? requestParamsConfig["standalone"] : requestParamsConfig["nonStandalone"];

  return {
    apiUrl,
    requestParams
  };
}

export const getInitTableData = ({
  responseData
}) => {
  return responseData.map(port => {

    const {
      activeState,
      seriesName
    } = port;

    const [ modelName, hwVer] = seriesName ? seriesName.split(/\//) : [];
    const formattedActiveState = labelMappingDefinition[activeState + ""] ?? labelMappingDefinition["false"];
    const formattedModelName = modelName ?? null;
    const formattedHwVer = hwVer ? hwVerDefinition[hwVer] ?? hwVer : null;
    const formattedHwVerLabel = formattedHwVer?.label ?? formattedHwVer ?? null;
    const formattedPortCount = port?.portConfigs?.length ?? null;
    const deviceCategory = port?.portConfigs?.[0]?.deviceCategory;

    return {
      ...port,
      formattedActiveState,
      formattedModelName,
      formattedHwVer,
      formattedHwVerLabel,
      formattedPortCount,
      deviceCategory,
    }
  })
}